function decodeHtmlEntities(text: string): string {
  if (typeof document === "undefined") return text;

  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
}

function stripTableDividerRows(text: string): string {
  return text
    .split("\n")
    .filter((line) => {
      const trimmed = line.trim();
      return !/^\|?[\s:-]+\|[\s|:-]*$/.test(trimmed);
    })
    .join("\n");
}

export function markdownToPlainText(markdown: string): string {
  const plainText = stripTableDividerRows(markdown)
    .replace(/\r\n?/g, "\n")
    .replace(/```[^\n]*\n([\s\S]*?)\n?```/g, "$1")
    .replace(/~~~[^\n]*\n([\s\S]*?)\n?~~~/g, "$1")
    .replace(/`([^`\n]+)`/g, "$1")
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/\[([^\]]+)\]\[[^\]]*\]/g, "$1")
    .replace(/^\s{0,3}\[[^\]]+\]:\s+\S+.*$/gm, "")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^[ \t]{0,3}>[ \t]?/gm, "")
    .replace(/^[ \t]*[-+*][ \t]+/gm, "")
    .replace(/^[ \t]*\d+[.)][ \t]+/gm, "")
    .replace(/^\s*\|(.+)\|\s*$/gm, (_match, cells: string) =>
      cells
        .split("|")
        .map((cell) => cell.trim())
        .join("\t")
    )
    .replace(/<\/?[^>]+>/g, "")
    .replace(/([*~]{1,3})(\S(?:.*?\S)?)\1/g, "$2")
    .replace(/(^|[^\w])(_{1,3})(\S(?:.*?\S)?)\2(?=$|[^\w])/g, "$1$3")
    .replace(/\\([\\`*_[\]{}()#+\-.!|>])/g, "$1")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return decodeHtmlEntities(plainText);
}
